import styled from 'styled-components';
import { OutboundLink } from 'gatsby-plugin-google-analytics';
import { Colors, MediaQueries } from 'environment';

export const Container = styled.div`
	padding-left: 4rem;
	padding: 0 4.5rem;
	margin-top: 12rem;

	@media ${MediaQueries.phone} {
		padding-left: 0;
		margin-top: 6rem;
	}

	@media ${MediaQueries.desktop} {
		margin-top: 0;
	}
`;

export const Row = styled.div`
	display: flex;
	flex-direction: row;
	align-items: center;

	:not(:first-child) {
		margin-top: 2.5rem;
	}
`;

export const IconContainer = styled.div`
	margin-right: 2rem;

	@media ${MediaQueries.phone} {
		margin-left: 0;
	}
`;

export const Title = styled.h4``;

export const Text = styled.p`
	margin-left: 6rem;
`;

export const CallToAction = styled(OutboundLink)`
	border-bottom: 0.2rem transparent solid;
	color: ${Colors.green};
	cursor: pointer;
	display: inline-block;
	margin-top: 1rem;
	margin-left: 6rem;
	transition: border-color 0.2s;

	:last-of-type {
		margin-top: 0;
	}

	&:hover {
		border-color: ${Colors.green};
	}
`;

export const Company = styled.div`
	margin-top: 2rem;
	padding-left: 6rem;

	span {
		display: block;
		margin-top: 1rem;
	}
`;

export const CompanyName = styled.p`
	font-weight: bold;
`;
